export default {
    token: state => state.app.token,
    studentName: (state, getters) => getters.userDetail.name || state.app.userInfo.name , // 学生姓名
    learnNum:(state, getters) => getters.userDetail.learnNum || state.app.userInfo.learnNum,//学号
    learnJi: (state, getters) => getters.userDetail.learnJi || state.app.userInfo.learnJi	,//学籍号
    cardId: (state, getters) => getters.userDetail.cardId !== undefined ?  getters.userDetail.cardId : state.app.userInfo.cardId,//身份证号
    birthDate: (state, getters) => getters.userDetail.birthDate || state.app.userInfo.birthDate,//出生日期
    regdPopulation: (state, getters) => getters.userDetail.regdPopulation || state.app.userInfo.regdPopulation,//是否在籍
    userInfoType: (state, getters) => getters.userDetail.type || state.app.userInfo.type,//学生状态
    schoolName: state => state.app.schoolInfo.name, // 学校名
    learnYear: (state, getters) => getters.userDetail.gradeLearnYear || (state.app.departInfo.parentDepart ? state.app.departInfo.parentDepart.learnYear : null) , // 入学年份
    learningStages: (state, getters) => getters.userDetail.gradeLearningStages || (state.app.departInfo.parentDepart ? state.app.departInfo.parentDepart.learningStages : null), // 学历
    departName: (state, getters) => getters.userDetail.className || state.app.departInfo.name, // 班级名称
    parentDepart: state => state.app.departInfo.parentDepart, //年级
    avatar: (state, getters) => getters.userDetail.avatar || state.app.userInfo.avatar, // 头像
    classId: (state, getters) => getters.userDetail.classId || state.app.departInfo.id, // 班级id
    schoolId: (state, getters) => getters.userDetail.schoolId || state.app.schoolInfo.id, // 学校id
    studentId: (state, getters) => getters.userDetail.id || state.app.userInfo.id, // 学生id
    permission: state => state.app.permissions, // 权限数据
    indexPermission: state => state.app.permissions, // 首页权限数据
    schoolTimeId: state => state.app.schoolTimeId, // 当前学年id
    fromExternal: state => state.app.fromExternal,
    userDetail: state => state.app.userDetail,
    userInfo: (state, getters) => state.app.userInfo,
    schoolInfo:  (state, getters) => state.app.schoolInfo,
}



// WEBPACK FOOTER //
// ./src/store/getters.js